export default __webpack_public_path__ + "static/media/covid.5a363cef.PNG";